export const formatDateTimeLocalValue = (date = new Date()) => {
  const sourceDate = date instanceof Date ? date : new Date(date);
  return new Date(sourceDate.getTime() - sourceDate.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 16);
};

export const toIsoStringKeepingLocalTime = (value) => {
  if (!value) return "";

  const sourceDate = value instanceof Date ? value : new Date(value);
  return new Date(sourceDate.getTime() - sourceDate.getTimezoneOffset() * 60000)
    .toISOString();
};